module.exports = __webpack_public_path__ + "static/findinpage-553734e48467a149064c7e03c1aa871a.png";